import { useProfile } from "./useProfile";
import type { PrescriptionType } from "@/lib/validations/medical-prescription";
import {
  validatePrescriptionProfile,
  type ProfileValidationResult,
} from "@/lib/prescriptions/profile-validation";

export type { ProfileValidationResult } from "@/lib/prescriptions/profile-validation";

export const useProfileValidation = (
  prescriptionType: PrescriptionType,
  controlRegime?: string,
) => {
  const { data: profile } = useProfile();

  return {
    profile,
    validate: (): ProfileValidationResult =>
      validatePrescriptionProfile(profile, prescriptionType, controlRegime),
  };
};
